import { mapGetters, mapMutations } from 'vuex'

const globalMixins = {
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters(['VuserInfo', 'VisLogin', 'Vcurrency', 'Vlang', 'VuserType', 'VcompanyInfo'])
  },
  mounted () {
    if (this._isMobile()) {
      // window.location.href = 'https://mobile.huayitraveltd.com'
    }
  },
  methods: {
    ...mapMutations(['setUserInfo', 'delUserInfo', 'setCurrency', 'setLang', 'setToken', 'setUserType', 'setCompanyInfo', 'setTureName', 'setMobile', 'setEmail']),
    _isMobile () {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    login () {
      this.$EventBus.$emit('loginRequest')
    },
    loginOut () {
      this.delUserInfo()
      this.backHome()
      window.location.reload(-1)
    },
    backHome () {
      this.$router.push({path: '/'})
    },
    getPhoto (type, src) {
      if (!src || src === '') return 'https://mobile.huayitraveltd.com/static/applogo-alpha.png'
      if (type === 'tour') {
        src = (src + '').split(',')[0]
        return 'https://tourimage.huayitraveltd.com' + src + '!200wp'
      } else if (type === 'tour2') {
        src = (src + '').split(',')[0]
        return 'https://tourimage.huayitraveltd.com' + src
      } else if (type === 'ticket') {
        src = (src + '').split(',')[0]
        if (src.indexOf('tourimage') >= 0) {
          return src + '!thumb1'
        } else if (src.indexOf('huayitraveltd') >= 0) {
          return src + '!thumb'
        } else {
          return src
        }
      } else if (type === 'hotel') {
        if (src.indexOf('tourimage') >= 0) {
          return src + '!thumb1'
        } else if (src.indexOf('huayitraveltd') >= 0) {
          return src + '!thumb'
        } else {
          return src
        }
      } else {
        src = (src + '').split(',')[0]
        if (src.indexOf('tourimage') >= 0) {
          return src + '!thumb1'
        } else {
          return src + '!thumb'
        }
      }
    },
    toCruise () {
      this.$router.push({
        path: '/cruise/list'
      })
    },
    backOrHome (homePath) {
      homePath = typeof homePath === 'undefined' ? '/' : homePath
      if (window.history.length <= 1) {
        this.$router.push({path: homePath})
      } else {
        this.$router.go(-1)
      }
    },
    toUserCenter () {
      if (this.VisLogin) {
        this.$router.push({
          path: '/user/orderList/all'
        })
      } else {
        this.$notify.warning({
          title: 'tips',
          message: this.$t('util.qxdl'),
          position: 'bottom-left'
        })
      }
    },
    toPay (Serial) {
      this.$router.push({
        name: 'PayIndex',
        params: {
          Serial: Serial
        }
      }).catch(err => {
        console.error(err)
      })
    },
    toHotel (id, dataSource, queryParams) {
      if (typeof id === 'undefined' || id === '') {
        this.$router.push({
          path: '/hotel/list'
        })
      } else {
        queryParams = typeof queryParams !== 'undefined' ? queryParams : {}
        const {href} = this.$router.resolve({
          path: `/hotel/${dataSource}/${id}`,
          query: queryParams
        })
        window.open(href, '_blank')
      }
    },
    toTicket (id, dataSource, queryParams) {
      if (typeof dataSource === 'undefined' || dataSource === '') {
        this.$router.push({
          path: '/ticket/list',
          query: {classId: id}
        })
      } else {
        queryParams = typeof queryParams !== 'undefined' ? queryParams : {}
        const {href} = this.$router.resolve({
          path: `/ticket/${dataSource}/${id}`,
          query: queryParams
        })
        window.open(href, '_blank')
      }
    },
    toPack (tagId) {
      this.$router.push({
        path: `/specialEvent/package/${tagId}`
      })
    },
    toTour (id, queryParams) {
      if (typeof id === 'undefined' || id === '') {
        this.$router.push({
          path: '/tour/list',
          query: {seasonId: queryParams}
        })
      } else {
        queryParams = typeof queryParams !== 'undefined' ? queryParams : {}
        const {href} = this.$router.resolve({
          path: `/tour/${id}`,
          query: queryParams
        })
        window.open(href, '_blank')
      }
    }
  }
}
export default globalMixins



// WEBPACK FOOTER //
// ./src/mixins/globalMixins.js